import axios from "axios"
import { IKiz2DocumentGetDTO } from "../../coreapi-dto/dirs/kiz";
import { envF } from "../../../env";
import { IInvoiceOutGetDTO } from "../../coreapi-dto/documents/invoiceOut";

export const getInvoiceOutItemUpdateDTO = async (idDocument: string, callback: (e) => void) => {

    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token
        },
    }

    const generateKizRequestUrl = (idDocumentItem) => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${idDocument}/Item/${idDocumentItem}`
    }

    const generateInvoiceRequestUrl = () => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/InvoiceOut/${idDocument}`
    }

    let invoiceOut = await axios.get<IInvoiceOutGetDTO>(
        generateInvoiceRequestUrl(),
        header
    )

    let items: any[] = []

    const itemsPush = async (x: any) => {
        if (!x.isKiz) {
            items.push({
                dateCreated: x.dateCreated,
                discountCostInfo: x.discountCostInfo,
                idGlobal: x.idGlobal,
                isKiz: x.isKiz,
                isKizBox: x.isKizBox,
                isOsu: x.isOsu,
                goodsCode: x.goodsCode,
                producer: x.producer,
                kizOsuDto: x.kizOsuDto,
                lot: x.lot,
                goods: x.goods,
                quantity: x.quantity,
                retailCostInfo: x.retailCostInfo,
                scalingRatioName: x.scalingRatioName,
                supplier: x.supplier,
                supplierCostInfo: x.supplierCostInfo,
                isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                goodsName: x.goodsName,
                gosContractFundingSourseName: x.gosContractFundingSourseName,
                financialSecurity: x?.financialSecurity
            })
        } else {
            await axios.get<IKiz2DocumentGetDTO>(
                generateKizRequestUrl(x.idGlobal),
                header
            ).then((e) => {
                items.push({
                    dateCreated: x.dateCreated,
                    discountCostInfo: x.discountCostInfo,
                    idGlobal: x.idGlobal,
                    isKiz: x.isKiz,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    isKizBox: x.isKizBox,
                    isOsu: x.isOsu,
                    kizOsuDto: x.kizOsuDto,
                    lot: x.lot,
                    goods: x.goods,
                    quantity: x.quantity,
                    retailCostInfo: x.retailCostInfo,
                    scalingRatioName: x.scalingRatioName,
                    supplier: x.supplier,
                    supplierCostInfo: x.supplierCostInfo,
                    kizs: e.data.items[0].kizes,
                    kizBoxes: e.data.items[0].kizBoxes,
                    kizBoxesGisMt: e.data.items[0].kizBoxesGisMt,
                    kizOsuDtos: e.data.items[0].kizOsuDtos,
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                    goodsName: x.goodsName,
                    gosContractFundingSourseName: x.gosContractFundingSourseName,
                    financialSecurity: x?.financialSecurity
                })
            }).catch(() => {
                items.push({
                    dateCreated: x.dateCreated,
                    discountCostInfo: x.discountCostInfo,
                    idGlobal: x.idGlobal,
                    isKiz: x.isKiz,
                    goodsCode: x.goodsCode,
                    producer: x.producer,
                    isKizBox: x.isKizBox,
                    isOsu: x.isOsu,
                    kizOsuDto: x.kizOsuDto,
                    lot: x.lot,
                    goods: x.goods,
                    quantity: x.quantity,
                    retailCostInfo: x.retailCostInfo,
                    scalingRatioName: x.scalingRatioName,
                    supplier: x.supplier,
                    supplierCostInfo: x.supplierCostInfo,
                    kizs: [],
                    kizBoxes: [],
                    kizBoxesGisMt: [],
                    kizOsuDtos: [],
                    isPieceAccountingKizOsu: x.isPieceAccountingKizOsu,
                    goodsName: x.goodsName,
                    gosContractFundingSourseName: x.gosContractFundingSourseName,
                    financialSecurity: x?.financialSecurity
                })
            })
        }
    }

    const addItems = async () => {
        const unresolvedPromises = invoiceOut.data.items.map((x) => itemsPush(x));
        await Promise.all(unresolvedPromises);
    }

    addItems().then(() => callback(items));
}